const mockCardapio = [
  {
    id: 1,
    nome: "Arroz com Coco e Tofu",
    ingredientes: "Arroz, coco, tofu",
    validade: "90 dias"
  }
];

module.exports = { mockCardapio };
